import { t } from '@/locales'
import type {
  TLabManagementRole,
  TLabManagementWorkArea,
} from '@team-milva/lab-models/user'

export function getRoleDisplayName(
  role: TLabManagementRole | TLabManagementWorkArea | 'none'
): string {
  switch (role) {
    case 'owner':
      return t('role.owner')
    case 'admin':
      return t('role.admin')
    case 'user':
      return t('role.user')
    case 'supporter':
      return t('role.supporter')
    case 'lab-assistant':
      return t('role.lab-assistant')
    case 'bookkeeper':
      return t('W: Bogholder')
    case 'none':
      return t('role.none')
    default:
      return t('role.none')
  }
}

export function getRoleDescription(
  role: TLabManagementRole | TLabManagementWorkArea | 'none'
): string {
  switch (role) {
    case 'owner':
      return t('role-description.owner')
    case 'admin':
      return t('role-description.admin')
    case 'user':
      return ''
    case 'supporter':
      return t('role-description.supporter')
    case 'lab-assistant':
      return t('role-description.lab-assistant')
    case 'bookkeeper':
      return t('W: Håndterer fakturering af ordrer')
    case 'none':
      return ''
    default:
      return ''
  }
}
